var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sd-rating-dropdown-item" }, [
    _c("span", { staticClass: "sd-rating-dropdown-item_text" }, [
      _vm._v(_vm._s(_vm.item.title)),
    ]),
    _vm._v(" "),
    !!_vm.item.description
      ? _c(
          "div",
          { staticClass: "sd-rating-dropdown-item_description" },
          [_c("survey-string", { attrs: { locString: _vm.item.description } })],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }